import {useQueryClient} from "@tanstack/react-query";

/** Additional query keys to invalidate (e.g. infinite scroll). Ensures refresh works on mobile. */
const ADDITIONAL_KEYS: Record<string, string[]> = {
  dars: ["infinite-dars"],
  incidentReports: ["infinite-incident-reports"],
  dispatchlogs: ["infinite-dispatch-logs"],
  vehicleconditionchecks: ["infinitevehicleconditionchecks"],
  "company-vehicles": ["infinite-company-vehicles"],
  poolaccesslogs: ["infinite-poolaccesslogs"],
  poolaccesslog: ["poolaccesslogs", "infinite-poolaccesslogs"],
  tennisaccesslogs: ["infinite-tennisaccesslogs"],
  tennisaccesslog: ["tennisaccesslogs", "infinite-tennisaccesslogs"],
  gymaccesslogs: ["infinite-gymaccesslogs"],
  gymaccesslog: ["gymaccesslogs", "infinite-gymaccesslogs"],
  recreationaccesslogs: ["infinite-recreationaccesslogs"],
  recreationaccesslog: ["recreationaccesslogs", "infinite-recreationaccesslogs"],
  tennis: ["infinite-tennis", "property_amenities"],
  tennis_amenity: ["tennis", "infinite-tennis", "property_amenities"],
  gym: ["infinite-gym", "property_amenities"],
  gym_amenity: ["gym", "infinite-gym", "property_amenities"],
  recreation: ["infinite-recreation", "property_amenities"],
  recreation_amenity: ["recreation", "infinite-recreation", "property_amenities"],
  propertyInspectionReports: ["infinite-property-inspection-reports"],
  user: ["users", "infinite-users-list"],
  users: ["infinite-users-list"],
  pools: ["infinite-pools", "property_amenities"],
  property_amenity: ["pools", "infinite-pools", "property_amenities"],
  properties: ["infinite-properties-list"],
  report_requests: ["infinite-reports"],
  households: ["infinite-households"],
  contacttelephones: ["infinitecontacttelephones"],
  briefingboards: ["infinite-briefing-boards"],
  "briefingboard-inbox": ["infinite-briefingboard-inbox"],
  "briefingboard-pending": [],
  "briefingboard-unread": ["briefingboard-inbox", "infinite-briefingboard-inbox", "briefingboard-pending"],
  briefingboard: ["briefingboard-recipients", "infinite-briefingboard-recipients"],
  citations: ["infinite-citations"],
  "stored-vehicles": ["infinite-stored-vehicles"],
  shifts: ["infinite-shifts", "shift-coverage"],
  "dispatch-centers": ["infinite-dispatch-centers"],
  "patrol-routes": ["infinite-patrol-routes"],
  "company-on-guard-users": [],
  permanentparkingtasks: ["infinitepermanentparkingtasks", "permanentparkingtask"],
  permanentparkingpermits: ["permanentparkingpermit", "infinite"],
  safelistings: ["infinite"],
  safelisting: ["safelistings", "infinite"],
  vehicles: ["infinite"],
};

export default function useInvalidate(queryKey: string) {
  const queryClient = useQueryClient();

  const handleInvalidate = () => {
    const keysToInvalidate = [
      queryKey,
      ...(ADDITIONAL_KEYS[queryKey] ?? []),
    ];

    keysToInvalidate.forEach((key) => {
      void queryClient.refetchQueries({queryKey: [key], type: "all"});
    });
  };

  return handleInvalidate;
}
